import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getAttendedPresentationList: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations`,
  },
  getAttendedPresentationDetail: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations/{id}`,
  },
  // V2 returns the same shape, but derives attendance from "Audiences" so the record points at
  // the session the participant actually joined. `{id}` is a presentationId here, not an
  // AttendedPresentations primary key — the list hands it back for the detail call either way.
  getAttendedPresentationListV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations/v2`,
  },
  getAttendedPresentationDetailV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/attended-presentations/v2/{id}`,
  },
  createAttendedPresentation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/attended-presentations`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

// `useV2` is passed in by the caller rather than read from the store here, so this module keeps
// no dependency on vuex (the store already imports the api layer).
const getAttendedPresentationList = async ({ page, pageSize, useV2 = false }) => {
  const res = useV2
    ? await resource.getAttendedPresentationListV2({ page, pageSize })
    : await resource.getAttendedPresentationList({ page, pageSize })

  return res.body
}

const getAttendedPresentationDetail = async (id, useV2 = false) => {
  const res = useV2
    ? await resource.getAttendedPresentationDetailV2({ id })
    : await resource.getAttendedPresentationDetail({ id })

  return res.body
}

const createAttendedPresentation = async (payload) => {
  const res = await resource.createAttendedPresentation(payload)

  return res.body
}

export default {
  initResource,
  getAttendedPresentationList,
  getAttendedPresentationDetail,
  createAttendedPresentation,
}
